import {
    type CategoryPage,
    isContentBlockSection,
    type Section,
    type TagPage,
    type UnityCategoryPage,
    type UnitySection,
    type UnityTagPage,
} from '@@api/services/placement/schemas';
import deserializeState from '@@plate/serialization/unity/utils/deserializeState';
import serializeState from '@@plate/serialization/unity/utils/serializeState';

export const deserializeSection = (section: UnitySection): Section =>
    isContentBlockSection(section) && section.content
        ? { ...section, content: deserializeState(section.content) }
        : (section as Section);

export const serializeSection = (section: Section): UnitySection =>
    isContentBlockSection(section) && section.content
        ? { ...section, content: serializeState(section.content) }
        : (section as UnitySection);

const deserializeSections = (sections: UnitySection[]): Section[] =>
    sections.map(deserializeSection);

export const serializeSections = (
    sections: Pick<Section, 'type'>[],
): Pick<UnitySection, 'type'>[] =>
    sections.map((section) =>
        isContentBlockSection(section) && section.content
            ? { ...section, content: serializeState(section.content) }
            : section,
    );

export const deserializeCategoryPage = (page: UnityCategoryPage): CategoryPage => ({
    ...page,
    sections: deserializeSections(page.sections) as CategoryPage['sections'],
});

export const deserializeTagPage = (page: UnityTagPage): TagPage => ({
    ...page,
    sections: deserializeSections(page.sections) as TagPage['sections'],
});
